// PE-6332 — chatbot asks the appointments page that is already open to cancel or reschedule
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface AppointmentChatAction {
  action: 'cancel' | 'reschedule';
  apptId: string;
}

@Injectable({ providedIn: 'root' })
export class AppointmentChatActionService {
  private readonly requests = new Subject<AppointmentChatAction>();

  readonly actions$: Observable<AppointmentChatAction> = this.requests.asObservable();

  request(action: AppointmentChatAction): void {
    const apptId = action.apptId.trim();
    if ((action.action === 'cancel' || action.action === 'reschedule') && /^[A-Za-z0-9-]+$/.test(apptId)) {
      this.requests.next({ action: action.action, apptId });
    }
  }
}
